import shoppingConfig from "emun.shopping/shopping.config";
import cartConfig from "emun.cart/cart.config";
import labels from "emun.order/_labels";
import basicController from "servicestack/basic.controller.properties";
import resolve from "ioc/resolve";
import orderConfig from "emun.order/order.config";
import productConfig from "emun.products/product.config";
import productLabels from "emun.products/_labels";
import { replaceSpaces } from "webutils/services/util";

const $localStorage = resolve("$localStorage");

export default class CartController {
  constructor($cart, $scope, $sce) {
    const $rootScope = resolve("$rootScope");
    const $ctrl = this;
    $ctrl.$cart = $cart;
    basicController($ctrl);
    $ctrl.replaceSpaces = replaceSpaces;
    $ctrl.shoppingConfig = shoppingConfig;
    $ctrl.labels = { ...productLabels, ...labels };
    $ctrl.config = cartConfig;
    $ctrl.orderConfig = orderConfig;
    $ctrl.productConfig = productConfig;
    $ctrl.isPromoCollapsed = $ctrl.orderConfig.collapsePromo;
    if (
      !$ctrl.orderConfig.collapseB2BPromo &&
      !$ctrl.$session.salesManagementMode
    ) {
      $ctrl.isPromoCollapsed = false;
    }
    if (!$ctrl.$session.salesManagementMode) $ctrl.showTotals = true;
    $ctrl.isB2BPromoCollapsed = $ctrl.orderConfig.collapseB2BPromo;
    $ctrl.months = $rootScope.$dates.monthNumbers; // Needed???
    $ctrl.years = $rootScope.$dates.getYears(); // Needed???
    $ctrl.$localStorage = $localStorage;
    $ctrl.history = window.history;
    $ctrl.$location = resolve("$location");
    if (!$ctrl.mode) {
      $ctrl.mode = $cart ? $cart.mode : null;
    }

    $ctrl.now = new Date();
  }
  toggleCheckoutCollapse() {
    const element = document.getElementById("checkout-collapse-grid");
    if (element) {
      element.classList.toggle("in");
    }
  }
  toggleCartMenu() {
		const slide = document.getElementById("cart-slide");
		if (slide) {
		  slide.classList.toggle("in");
		}
	}
	setDate(date) {
		const $ctrl = this;
    console.debug("BL*** $ctrl.cartItem.shipOn", $ctrl.cartItem.shipOn);
		$ctrl.cartItem.shipOn = moment.utc(date);
    console.debug("BL*** $ctrl.cartItem.shipOn", $ctrl.cartItem.shipOn);
	}
  historyBack() {
    let $ctrl = this;
    window.history.back();
  }
}
